<script setup>
import { computed, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

defineProps({ inboxes: { type: Array, required: true } });
const emit = defineEmits(['create']);
const { t } = useI18n();
const dialogRef = ref(null);
const isSubmitting = ref(false);
const state = reactive({
  inboxId: '',
  name: '',
  language: 'pt_BR',
  category: 'MARKETING',
  body: '',
  footer: '',
});
const canSubmit = computed(
  () => state.inboxId && state.name && state.language && state.body
);
const open = () => dialogRef.value?.open();
const submit = async () => {
  if (!canSubmit.value) return;
  isSubmitting.value = true;
  const components = [{ type: 'BODY', text: state.body }];
  if (state.footer) components.push({ type: 'FOOTER', text: state.footer });
  emit('create', {
    inboxId: state.inboxId,
    template: {
      name: state.name,
      language: state.language,
      category: state.category,
      components,
    },
  });
  isSubmitting.value = false;
};
defineExpose({ open, close: () => dialogRef.value?.close() });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="lg"
    :title="t('WHATSAPP_TEMPLATE_MGMT.CREATE.TITLE')"
    :description="t('WHATSAPP_TEMPLATE_MGMT.CREATE.DESCRIPTION')"
    :confirm-button-label="t('WHATSAPP_TEMPLATE_MGMT.CREATE.SUBMIT')"
    :disable-confirm-button="!canSubmit"
    :is-loading="isSubmitting"
    @confirm="submit"
  >
    <div class="flex flex-col gap-4">
      <label class="flex flex-col gap-1 text-sm text-n-slate-12">
        <span>{{ t('WHATSAPP_TEMPLATE_MGMT.CREATE.INBOX') }}</span>
        <select
          v-model="state.inboxId"
          class="px-3 py-2 border rounded-lg border-n-strong bg-n-alpha-3"
        >
          <option disabled value="">
            {{ t('WHATSAPP_TEMPLATE_MGMT.CREATE.SELECT_INBOX') }}
          </option>
          <option v-for="inbox in inboxes" :key="inbox.id" :value="inbox.id">
            {{ inbox.name }}
          </option>
        </select>
      </label>
      <Input
        v-model="state.name"
        :label="t('WHATSAPP_TEMPLATE_MGMT.CREATE.NAME')"
        :placeholder="t('WHATSAPP_TEMPLATE_MGMT.CREATE.NAME_HINT')"
      />
      <Input
        v-model="state.language"
        :label="t('WHATSAPP_TEMPLATE_MGMT.CREATE.LANGUAGE')"
      />
      <label class="flex flex-col gap-1 text-sm text-n-slate-12">
        <span>{{ t('WHATSAPP_TEMPLATE_MGMT.CREATE.CATEGORY') }}</span>
        <select
          v-model="state.category"
          class="px-3 py-2 border rounded-lg border-n-strong bg-n-alpha-3"
        >
          <option value="MARKETING">
            {{ t('WHATSAPP_TEMPLATE_MGMT.CREATE.MARKETING') }}
          </option>
          <option value="UTILITY">
            {{ t('WHATSAPP_TEMPLATE_MGMT.CREATE.UTILITY') }}
          </option>
        </select>
      </label>
      <label class="flex flex-col gap-1 text-sm text-n-slate-12">
        <span>{{ t('WHATSAPP_TEMPLATE_MGMT.CREATE.BODY') }}</span>
        <textarea
          v-model="state.body"
          rows="4"
          class="px-3 py-2 border rounded-lg border-n-strong bg-n-alpha-3"
        />
      </label>
      <Input
        v-model="state.footer"
        :label="t('WHATSAPP_TEMPLATE_MGMT.CREATE.FOOTER')"
      />
    </div>
  </Dialog>
</template>
